const map =  {
    init: () => {
        function new_map($el) {
            var $markers = $el.find('.marker');
    
            var args = {
                zoom: 4,
                center: new google.maps.LatLng(47.168462, 19.395633),
                mapTypeId: google.maps.MapTypeId.ROADMAP,
                styles: [
                    {
                      "featureType": "poi.business",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "poi.park",
                      "elementType": "labels.text",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    },
                    {
                      "featureType": "road",
                      "stylers": [
                        {
                          "visibility": "off"
                        }
                      ]
                    }
                  ]
            };
    
            // create map
            var map = new google.maps.Map($el[0], args);
    
            // add a markers reference
            map.markers = [];
    
            // add markers
            $markers.each(function () {
                add_marker($(this), map);
            });
    
            // center map
            center_map(map);
    
            // return
            return map;
        }
    
        /*
         *  add_marker
         *
         *  This function will add a marker to the selected Google Map
         *
         *  @type	function
         *  @date	8/11/2013
         *  @since	4.3.0
         *
         *  @param	$marker (jQuery element)
         *  @param	map (Google Map object)
         *  @return	n/a
         */
    
        function add_marker($marker, map) {
            var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
    
            // create marker
            var marker = new google.maps.Marker({
                position: latlng,
                map: map,
                icon: {
                    url: ajax.themeurl + '/assets/img/svg/pin.svg',
                    scaledSize: new google.maps.Size(56, 56)
                },
            });
    
            // add to array
            map.markers.push(marker);
    
            google.maps.event.addListener(marker, 'click', function () {
            $('.js-map-vinery-cards').addClass('d-none');
            $(`.section-map #${$marker.data('id')}`).removeClass('d-none');

            if (currentmarker != this) {
                        marker.setIcon({
                            url: ajax.themeurl + '/assets/img/svg/pin_active.svg',
                            scaledSize: new google.maps.Size(56, 56),
                        });

                        if (currentmarker) {
                currentmarker.setIcon({
                  url: ajax.themeurl + '/assets/img/svg/pin.svg',
                  scaledSize: new google.maps.Size(56, 56)
                });
                currentmarker = null;
              }
              currentmarker = this;
                    }
          });
        }
    
        /*
         *  center_map
         *
         *  This function will center the map, showing all markers attached to this map
         *
         *  @type	function
         *  @date	8/11/2013
         *  @since	4.3.0
         *
         *  @param	map (Google Map object)
         *  @return	n/a
         */
    
        function center_map(map) {
            var bounds = new google.maps.LatLngBounds();
    
            // loop through all markers and create bounds
            $.each(map.markers, function (i, marker) {
                var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
                bounds.extend(latlng);
            });
    
            map.setZoom(8);
        }
    
        /*
         *  document ready
         *
         *  This function will render each map when the document is ready (page has loaded)
         *
         *  @type	function
         *  @date	8/11/2013
         *  @since	5.0.0
         *
         *  @param	n/a
         *  @return	n/a
         */
        // global var
        var map = null;
		var currentmarker = null;
    
        $('.js-simple-map').each(function () {
            map = new_map($(this));
        });

        $('.js-close-card-map').on('click', function() {
          $('.js-map-vinery-cards').addClass('d-none');
        });

    }, 
   
}
